import {useCallback, useState} from "react";

type HookReturn = {
    playingIndex: number | null;
    handlePlay: (index: number) => void;
    stopAll: () => void;
};

export function useVideoInteraction(): HookReturn {
    const [playingIndex, setPlayingIndex] = useState<number | null>(null);

    const handlePlay = useCallback((index: number): void => {
        setPlayingIndex(index);
    }, []);

    const stopAll = useCallback((): void => {
        setPlayingIndex(null);
    }, []);

    return {playingIndex, handlePlay, stopAll};
}
